import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogConfig as MatDialogConfig } from '@angular/material/legacy-dialog';
import { Observable, of } from 'rxjs';
import { FolderDataService } from '../../../dave-data-module/services/folder-data.service';
import { FolderTypes } from '../../../dave-data-module/entities/folder.entity';
import { map, shareReplay } from 'rxjs/operators';
import { MaterialMainDataComponent } from '../material-main-data/material-main-data.component';
import { isNotNullOrUndefined } from '../../../helper/helper';
import { MaterialEntity } from '../../../dave-data-module/entities/material.entity';


export interface MaterialMainDataPopupComponentDialogData {
    MaterialId: number;
    newMaterialDefaultValues?: MaterialMainDataComponent['newMaterialDefaultValues'];
    initialEditMode?: boolean;
}
@Component({
  selector: 'app-material-main-data-popup',
  templateUrl: './material-main-data-popup.component.html',
  styleUrls: ['./material-main-data-popup.component.scss']
})
export class MaterialMainDataPopupComponent {

    public static DefaultConfig: MatDialogConfig = {
        maxWidth: '100vw',
        hasBackdrop: false,
        closeOnNavigation: true,
        panelClass: 'custom-dialog-class-for-overlay-on-right-side',
    };
    public Editing = false;
    public FolderId$: Observable<number>;
    @Output() submitted = new EventEmitter<MaterialEntity>();
    constructor(
        @Inject(MAT_DIALOG_DATA)
        public Dialogdata: MaterialMainDataPopupComponentDialogData,
        folderDataService: FolderDataService,
    ) {
        if (isNotNullOrUndefined(Dialogdata.initialEditMode)) {
            this.Editing = Dialogdata.initialEditMode;
        }
        this.FolderId$ = Dialogdata.MaterialId ? folderDataService.getFolderFromEntity(Dialogdata.MaterialId, FolderTypes.resource).pipe(
            map((folders) => folders?.Id),
            shareReplay({bufferSize: 1, refCount: true}),
        ) : of(null);
    }

}
